<template>
    <ul class="text-list">
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-luggage-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-luggage-blue.svg" width="18" height="18">
            Travel Plans
        </li>
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-plane-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-plane-blue.svg" width="18" height="18">
            Flights
        </li>
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-bed-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-bed-blue.svg" width="18" height="18">
            Accommodation
        </li>
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-food-drink-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-food-drink-blue.svg" width="18" height="18">
            Food &amp; Drink
        </li>
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-car-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-car-blue.svg" width="18" height="18">
            Cars &amp; Transportation
        </li>
        <li class="text-list__item">
            <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-tours-black.svg" width="18" height="18">
            <img v-else class="icon" src="../assets/icons/icon-tours-blue.svg" width="18" height="18">
            Tours &amp; Tickets
        </li>
        <li class="text-list__item last">
            <span class="round">
                <img v-if="color === '#000'" class="icon" src="../assets/icons/icon-shop-white.svg" width="18" height="18">
                <img v-else class="icon" src="../assets/icons/icon-shop-blue.svg" width="18" height="18">
            </span>
            At the same time
        </li>
    </ul>
</template>
<script>
export default
{
    name: 'logo-travelshift',

    props: {
        color: { type: String, default: '#000' },
        width: { type: Number, default: 240 },
        height: { type: Number, default: 35 }
    }
}
</script>
<style lang="sass" scoped>
@import "../style/_settings/__index.sass"
@import "../style/_required/_index.sass"

.text-list
    color: #000

    &.is-small
        +font-size(18px)

    &>*:last-child
        margin-bottom: 3em

    .text-list__item
        line-height: 1.4em
        margin-bottom: 0.5em

        &:before
            display: none

        .icon
            margin-right: 1.5em

        &.last
            @extend %font-medium
            color: map-get($colors, "green")
            position: relative
            margin-top: 1em
            padding-top: 1.5em
            border-top: 1px solid rgba(0, 0, 0, 0.2)
            margin-bottom: 0

            *
                vertical-align: top

            .round
                position: relative
                width: 50px
                height: 50px
                background: map-get($colors, "green")
                display: inline-block
                border-radius: 50%
                margin: -0.5em 0.7em 0 -15px

                .icon
                    position: absolute
                    top: 50%
                    left: 50%
                    transform: translateX(-50%) translateY(-50%)

            .icon
                position: relative

    &.is-blue
        @extend %font-light
        color: map-get($colors, "blue")

        .text-list__item
            line-height: 1.7em

            .icon
                transform: scaleX(0.9) scaleY(0.9)

            &.last
                color: #FFF
                border-color: rgba(map-get($colors, "blue"), 0.6)

                .round
                    background: #FFF

                &:before
                    background: #FFF

    &.is-small
        .text-list__item
            &.last
                &:before
                    width: 40px
                    height: 40px
                    left: 1px


@media screen and (max-width: 1280px)
    .text-list
        margin-left: (100% * 1 / 6.5)

@media screen and (max-width: 960px)
    .text-list
        margin: 0

@media screen and (max-width: 640px)
    .text-list__item
        +font-size(18px)

@media screen and (max-width: 420px)
    .text-list__item
        +font-size(16px)

</style>
